import ivanov_ivan from './ivanov-ivan.jpg'

export { ivanov_ivan }
